import React from "react";

import * as S from "./styles";

export const Banner: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title>
          <span>Ouvidoria</span> Orthopride
        </S.Title>
      </S.Wrapper>
    </S.Container>
  );
};
